import React from 'react';
import type { JITRequirement } from './useJITCollect';
import useJITCollect from './useJITCollect';

// declare requirements outside of function so that array is not recreated on each rerender
const collectUserFirstNameRequirements: JITRequirement[] = ['user-firstName'];

export function useUserFirstNameJITCollect() {
  const collectUserFirstName = useJITCollect(collectUserFirstNameRequirements);
  React.useEffect(() => {
    collectUserFirstName?.();
  }, [collectUserFirstName]);
}
